import { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

export default function LanguageSync() {
  const { lang } = useParams();
  const { setLanguage, SUPPORTED } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (lang && SUPPORTED.includes(lang)) {
      setLanguage(lang);
      localStorage.setItem("language", lang);
    } else if (lang && !SUPPORTED.includes(lang)) {
      // Invalid lang prefix, redirect to en
      const newPath = location.pathname.replace(`/${lang}`, "/en");
      navigate(newPath, { replace: true });
    }
  }, [lang]);

  return null;
}